<template lang="pug">
.bp-footer.bg-tdays-dark
  .h3.text-center.txt-white.py-4 Die touriDays-Garantie inklusive aller benannten Leistungen ist automatisch in jedem Urlaubsangebot von touriDat enthalten - Ihr Kauf ist zu 100% sicher!
</template>

<script>
export default {
  name: "BuyersProtectionFooter"
}
</script>